/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TypeDiplomeResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { TypeDiplomeViewDTO, RequestOptions, TypeDiplomeListDTO } from "../models";

@Injectable({ providedIn: "root" })
export class TypeDiplomeResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    addorUpdateTypesDiplome(typeDiplomeViewDTO: TypeDiplomeViewDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    addorUpdateTypesDiplome(typeDiplomeViewDTO: TypeDiplomeViewDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    addorUpdateTypesDiplome(typeDiplomeViewDTO: TypeDiplomeViewDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    addorUpdateTypesDiplome(typeDiplomeViewDTO: TypeDiplomeViewDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/addorUpdateTypesDiplome`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: typeDiplomeViewDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllTypeDiplomes(archive?: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TypeDiplomeListDTO>>;
    getAllTypeDiplomes(archive?: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TypeDiplomeListDTO>>>;
    getAllTypeDiplomes(archive?: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TypeDiplomeListDTO>>>;
    getAllTypeDiplomes(archive?: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types`;

        let params = new HttpParams();
        if (archive != null) {
            params = HttpParamsBuilder.addToHttpParams(params, archive, 'archive');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTypesDiplomeById(idTypesDiplome?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    getTypesDiplomeById(idTypesDiplome?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    getTypesDiplomeById(idTypesDiplome?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    getTypesDiplomeById(idTypesDiplome?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/types-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTypesDiplomeById1(idTypesDiplome?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    getTypesDiplomeById1(idTypesDiplome?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    getTypesDiplomeById1(idTypesDiplome?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    getTypesDiplomeById1(idTypesDiplome?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/types-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTypesDiplomeById2(idTypesDiplome?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    getTypesDiplomeById2(idTypesDiplome?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    getTypesDiplomeById2(idTypesDiplome?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    getTypesDiplomeById2(idTypesDiplome?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/types-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTypesDiplomeById4(idTypesDiplome?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    getTypesDiplomeById4(idTypesDiplome?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    getTypesDiplomeById4(idTypesDiplome?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    getTypesDiplomeById4(idTypesDiplome?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/types-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTypesDiplomeById3(idTypesDiplome?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    getTypesDiplomeById3(idTypesDiplome?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    getTypesDiplomeById3(idTypesDiplome?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    getTypesDiplomeById3(idTypesDiplome?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/types-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTypesDiplomeById6(idTypesDiplome?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    getTypesDiplomeById6(idTypesDiplome?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    getTypesDiplomeById6(idTypesDiplome?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    getTypesDiplomeById6(idTypesDiplome?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/types-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getTypesDiplomeById5(idTypesDiplome?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<TypeDiplomeViewDTO>;
    getTypesDiplomeById5(idTypesDiplome?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TypeDiplomeViewDTO>>;
    getTypesDiplomeById5(idTypesDiplome?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TypeDiplomeViewDTO>>;
    getTypesDiplomeById5(idTypesDiplome?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/diplomes/types/types-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
